import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { Kicker } from "@/components/form";
import { api } from "@/lib/api";

export default function Ratgeber() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="ratgeber-page" className="bg-navy-900 min-h-screen">
      <Seo title="Ratgeber" description="Ratgeber und Expertentipps von VM-FFM.DE zu Versicherung, Finanzierung und Immobilien." path="/ratgeber" keywords="Versicherung Ratgeber, Finanzierung Tipps, Immobilien Blog" />
      <section className="pt-40 pb-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <Kicker>Ratgeber & Wissen</Kicker>
          <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter text-white leading-none">Expertenwissen für Ihre Entscheidungen.</h1>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((p, i) => (
              <motion.div key={p.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}>
                <Link to={`/ratgeber/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block h-full bg-navy-800 border border-white/5 rounded-md overflow-hidden hover:-translate-y-1 hover:border-gold-500/40 transition-[transform,border-color] duration-300">
                  <div className="aspect-video overflow-hidden"><img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
                  <div className="p-6">
                    <span className="text-xs uppercase tracking-wide text-gold-500 font-bold">{p.category}</span>
                    <h3 className="mt-2 text-lg font-bold text-white leading-snug">{p.title}</h3>
                    <p className="mt-2 text-sm text-slate-400 leading-relaxed line-clamp-3">{p.excerpt}</p>
                    <span className="mt-4 inline-flex items-center gap-2 text-gold-500 text-sm font-medium">Weiterlesen <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" /></span>
                  </div>
                </Link>
              </motion.div>
            ))}
            {posts.length === 0 && <p className="text-slate-500 col-span-full">Noch keine Beiträge.</p>}
          </div>
        </div>
      </section>
    </div>
  );
}
